module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Challenger.bef3bca3.svg";